var map = {
	"./activation.svg": "2763",
	"./bot-contract-deactivation.svg": "a8cf",
	"./bot-contract.svg": "3d03",
	"./coinbase.svg": "0dbf",
	"./deal-contract.svg": "2c47",
	"./funding-contract.svg": "5d68",
	"./minting-contract.svg": "7c72",
	"./minting.svg": "2053",
	"./platincoin-contract.svg": "3ac5",
	"./standard.svg": "40ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df00";